import CheckboxInputGroup from '@root/core/src/components/checkbox-input-group';
import CheckboxOption from '@root/core/src/components/checkbox-option';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import SnolStyles from '@root/claims.joinroot.com/src/assets/snol-styles';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function InjuryCategoriesQuestion(props) {
  const {
    currentName,
    currentSelectedInjuryCategories,
    injuryCategories,
    inputKey,
    isError,
    onFieldEvent,
  } = props;

  const identifier = currentName?.trim() || 'this person';

  const optionIsSelected = (option) => {
    return currentSelectedInjuryCategories[option.value];
  };

  const optionEventHandler = (option) => {
    return (value) => {
      const newSelectedInjuryCategories = Object.assign({}, currentSelectedInjuryCategories);
      newSelectedInjuryCategories[option.value] = value;

      onFieldEvent(newSelectedInjuryCategories);
    };
  };

  return (
    <CheckboxInputGroup>
      <h4 css={[SnolStyles.injuryQuestion, styles.marginTop40]}>Did {identifier} experience any of these injuries because of the accident?</h4>
      <p css={SnolStyles.injurySubtext}>Select all that apply.</p>
      {injuryCategories.map((option, index) =>
        (
          <div key={index}>
            <CheckboxOption
              disabled={option.disabled || false}
              id={`${inputKey}-injury-option-${option.value}`}
              isError={isError}
              isSelected={optionIsSelected(option) || false}
              key={index}
              label={option.label}
              name={`${inputKey}-injury-category-option`}
              onChange={optionEventHandler(option)}
              optionValue={option.value}
            />
          </div>
        )
      )}
    </CheckboxInputGroup>
  );
}

const styles = StyleSheet.create({
  marginTop40: {
    marginTop: '40px',
  },
});

InjuryCategoriesQuestion.propTypes = {
  currentName: PropTypes.string,
  currentSelectedInjuryCategories: PropTypes.objectOf(PropTypes.bool).isRequired,
  injuryCategories: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })).isRequired,
  inputKey: PropTypes.string.isRequired,
  isError: PropTypes.bool.isRequired,
  onFieldEvent: PropTypes.func.isRequired,
};
